const BYTE_CHUNK_SIZE = 32 * 1024;
const BASE64URL_PATTERN = /^[A-Za-z0-9_-]+$/;

export function toBase64Url(bytes: Uint8Array): string {
  let binary = '';
  for (let offset = 0; offset < bytes.length; offset += BYTE_CHUNK_SIZE) {
    binary += String.fromCharCode(...bytes.subarray(offset, offset + BYTE_CHUNK_SIZE));
  }
  return btoa(binary).replace(/\+/gu, '-').replace(/\//gu, '_').replace(/=+$/u, '');
}

export function fromBase64Url(token: string): Uint8Array {
  if (!BASE64URL_PATTERN.test(token) || token.length % 4 === 1) {
    throw new Error('无效的 Base64URL 内容');
  }

  const padded = `${token.replace(/-/gu, '+').replace(/_/gu, '/')}${'='.repeat((4 - token.length % 4) % 4)}`;
  let binary: string;
  try {
    binary = atob(padded);
  } catch {
    throw new Error('无效的 Base64URL 内容');
  }

  const bytes = new Uint8Array(binary.length);
  for (let offset = 0; offset < binary.length; offset += BYTE_CHUNK_SIZE) {
    const end = Math.min(offset + BYTE_CHUNK_SIZE, binary.length);
    for (let index = offset; index < end; index += 1) bytes[index] = binary.charCodeAt(index);
  }
  return bytes;
}
